export default __webpack_public_path__ + "static/media/photo-icon.a27e236d.svg";